// extracted by mini-css-extract-plugin
export default {"layout":"_899502ed2e _19a15ef612 d971e78976","h_slide":"ee46fb53fa","category":"f54fec36ab _4f1fb63138 _0a7ffed91e"};